import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFramer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFramer"><Path d="M18.6693 2V8.66667H12.0026L5.33598 2H18.6693Z" fill="currentColor"/><Path d="M5.33594 8.66667H12.0026L18.6693 15.3333H12.0026V22L5.33594 15.3333V8.66667Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFramer;
